import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import T from '../../Helpers/translate';
import Bem from '@upsales/components/Utils/bemClass';
import {
	Table,
	TableColumn,
	TableHeader,
	TableRow,
	Card,
	CardHeader,
	Icon,
	Text,
	Input,
	Avatar,
	Paginator,
	Flex
} from '@upsales/components';

import {
	getAllListViewsExceptStandard,
	adminSearchString,
	makeOwner,
	openModal,
	reset
} from 'Store/reducers/SharedViewsReducer';
import AdminHeader from '../AdminHeader';

import './SharedViewsAdmin.scss';

const mapStateToProps = state => ({
	allViews: state.SharedViews.allListViews,
	searchString: state.SharedViews.adminSearchString
});

const mapDispatchToProps = {
	getAllListViewsExceptStandard,
	adminSearchString,
	makeOwner,
	openModal,
	reset
};

class SharedViewsAdmin extends React.Component {
	state = {
		loading: false,
		views: [],
		offset: 0,
		limit: 50,
		total: 0
	};

	componentDidMount() {
		this.props.reset();
		this.fetchPage();
	}

	async fetchPage() {
		this.setState({ loading: true });
		try {
			const { offset, limit } = this.state;
			const { searchString } = this.props;
			const params = { limit, offset };
			if (searchString) {
				params.query = searchString;
			}
			const res = await window.Tools.ListViews.getSharedPaged(params);
			this.setState({
				views: res.data,
				total: Number(res.metadata?.total ?? 0),
				loading: false
			});
		} catch (e) {
			this.setState({ loading: false });
		}
	}

	handlePageChange = nextOffset => {
		this.setState({ offset: nextOffset }, () => this.fetchPage());
	};

	handleSearchChange = event => {
		const value = event.target.value;
		this.props.adminSearchString(value);
		this.setState({ offset: 0 }, () => this.fetchPage());
	};

	row(view) {
		const userroles = view.users.concat(view.roles).filter(item => item.name);
		let sharedColumn = T('default.private');
		if (userroles.length === 1) {
			sharedColumn = `${userroles[0].name}`;
		}

		if (userroles.length > 1) {
			sharedColumn = `${userroles[0].name} + ${userroles.length - 1} ${T('default.more2').toLowerCase()}`;
		}

		return (
			<TableRow
				key={`${view.title}-${view.id}`}
				onClick={() => {
					this.props.openModal(view);
				}}
			>
				<TableColumn size="lg">
					<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
						<Text bold>{view.title}</Text>
						<Text size="sm" color="bright-blue" style={{ lineHeight: '12px' }}>
							{T(`sharedViews.subtitle.${view.type}`)}
						</Text>
					</div>
				</TableColumn>
				<TableColumn size="lg">
					<Text color="bright-blue">{sharedColumn}</Text>
				</TableColumn>
				<TableColumn size="lg" style={{ display: 'flex', alignItems: 'center' }}>
					<Avatar size="sm" initials={view.regBy.name} email={view.regBy.email} />
					<Text style={{ display: 'inline-block' }}>{view.regBy.name}</Text>
				</TableColumn>
				<TableColumn size="lg" align="right">
					<Icon name="pencil-square-o" />
				</TableColumn>
			</TableRow>
		);
	}

	render() {
		const { views, limit, offset, total } = this.state;
		const MainClass = new Bem('SharedViewsAdmin');

		const pagination = { limit, offset, total };

		return (
			<div id="admin-root" className={MainClass}>
				<AdminHeader
					title={T('sharedViews.sharedViews')}
					image="admin-shared-views.svg"
					description={T('sharedViews.admin.headerDescription')}
				/>
				<div id="admin-content">
					<Card>
						<CardHeader title={T('sharedViews.viewsUsers')}>
							<Input
								noborder
								color="grey-2"
								icon="search"
								onChange={this.handleSearchChange}
								placeholder={T('sharedViews.searchView')}
							/>
						</CardHeader>
						<Table>
							<TableHeader
								columns={[
									{ title: T('sharedViews.cols.viewName') },
									{ title: T('sharedViews.cols.sharedWith') },
									{ title: T('sharedViews.cols.ownedBy') },
									{}
								]}
							/>
							{views.map(view => {
								return this.row(view);
							})}
						</Table>
						{pagination.total > pagination.limit ? (
							<Flex spacing="pb4" justifyContent="center">
								<Paginator onChange={this.handlePageChange} {...pagination} />
							</Flex>
						) : null}
					</Card>
				</div>
			</div>
		);
	}
}

SharedViewsAdmin.propTypes = {
	getAllListViewsExceptStandard: PropTypes.func,
	adminSearchString: PropTypes.func,
	allViews: PropTypes.array,
	makeOwner: PropTypes.func,
	searchString: PropTypes.string,
	openModal: PropTypes.func
};

export const detached = SharedViewsAdmin;
const ConnectComponent = connect(mapStateToProps, mapDispatchToProps)(SharedViewsAdmin);
const WrappedSharedViewsAdmin = props => {
	return (
		<div id="admin" className="WrappedSharedViewsAdmin">
			<ConnectComponent {...props} />
		</div>
	);
};
export const SharedViewsAdminPorted = WrappedSharedViewsAdmin;
export default ConnectComponent;
